/** 浏览器本地存储封装（F-003 场景 / F-011 策略 持久化）。所有键加统一前缀，失败静默。 */
const PREFIX = 'elev:';

export function loadJSON<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function saveJSON(key: string, val: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(val));
  } catch {
    /* 配额满 / 隐私模式不可用 —— 静默，内存态仍可用 */
  }
}

export function removeKey(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}
